<template>
    <div class="bg-white grid grid-cols-1 place-content-between p-4 min-w-fit min-h-112" :class="{ 'h-52 min-w-336': isAbilitato }">
            <div class="flex flex-shrink font-bold">Alert Automatico</div>
        <div v-show="isAbilitato" class="flex flex-col items-start">
            <div class="flex-shrink text-sm">Inizio attività</div>
            <div class="flex-shrink text-2xl">{{inizio}}</div>
        </div>
        <div class="flex justify-center" :class="{ 'justify-between':isAbilitato }">
            <div v-show="isAbilitato" class="basis-1/2 flex  flex-col items-start">
                <div class="flex-shrink text-sm">Prossimo alert</div>
                <div class="flex-shrink text-2xl">{{scadenza}}</div>
            </div>
            <NextButton @click="$emit('changeState')" variant="outline-secondary" :class="{ 'ml-3':isAbilitato }" class="basis-1/4 self-center px-3 py-1">{{buttonLabel}}</NextButton>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";

@Options({
    name:'AlertAutomatico',
    components: {NextButton},
    props: {
        id: [String,Number],
        inizio: String,
        scadenza: String,
        abilitato: [Boolean,Number,String],
    }
})
export default class AlertAutomatico extends Vue {
    id!: string
    inizio!: string
    scadenza!: string
    abilitato!: boolean|number|string

    get buttonLabel(){
        return this.isAbilitato ? 'Disabilita' : 'Abilita'
    }

    get isAbilitato() {
        return this.abilitato != '0'
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
